module.exports = __webpack_public_path__ + "fb284a8fda177158aecf629ab657c34f.svg";